export class Student {
  id: number;
  checked: boolean;
  //  A. THÔNG TIN HỌC SINH
  //  Thông tin cá nhân
  avata: string
  /*Mã định danh*/
  studentCode: string;
  /*Mã định danh cấp Tỉnh*/
  studentProvinceCode: string;
  /*Mã định danh cấp Bộ*/
  studentMinistryCode: string
  /*Họ và tên*/
  fullName: string
  firstName: string
  lastName: string
  /*Năm sinh*/
  yearOfBirth: number;
  /*Nơi sinh*/
  placeOfBirthId: string;
  placeOfBirth: string;
  /*Hộ chiếu*/
  passport: string;
  /*Giới tính*/
  gender: number;
  /*Dân tộc*/
  folkId: number;
  folk: string;
  tutorFolk: string;
  /*Quốc tịch*/
  nationalityId: number;
  /*Tôn giáo*/
  religionId: number;
  /*Nghề nghiệp người giám hộ*/
  tutorCareerId?: number;
  //  Thông tin liên lạc
  /*CMND/CCCD/Mã công dân*/
  idNumber: string;
  /*Nơi cấp*/
  issuedBy: string;
  /*Ngày cấp*/
  idNumberDate: string;
  /*Số điện thoại*/
  listStudentFacilitiesAndEquipmentNkt: any[];
  facilitiesAndEquipmentNkt: string;
  phoneNumber: string
  /*Email*/
  email: string;
  /*Tỉnh thành*/
  provinceId: number;
  /*Quận huyện*/
  districtId: number;
  /*Phường xã*/
  wardId: number;
  /* Thông tin người giám hộ*/
  /*Họ tên NGH*/
  tutorName: string;
  /*Năm sinh NGH*/
  tutorBirthYear: number;
  /*Số điện thoại*/
  tutorPhone: string;
  /*Email*/
  tutorEmail: string;
  /*CMND/CCCD/Mã công dân*/
  tutorIDNumber: string;
  /*Hộ chiếu*/
  tutorPassport: string;
  /*Nghề nghiệp NGH*/
  tutorCareer: string;
  /*Địa chỉ*/
  tutorAddress: string;
  /*Điều kiện kinh tế gia đình*/
  tutorLivingConditionId: number;
  /*Trình độ*/
  tutorEducationLevelId: number;
  /*Dân tộc*/
  tutorFolkId: number;
  /*Chưa Bồi dưỡng nghiệp vụ*/
  tutorUnfostered: boolean;
  /*Chứng nhận*/
  tutorCertificated: boolean;
  /*Chứng chỉ*/
  tutorLicensed: boolean;
  tutorCD: boolean;
  tutorDH: boolean;
  tutorSDH: boolean;
  tutorCNCC: boolean;
  /* Thông tin khuyết tật*/
  /*Giấy chứng nhận khuyết tật*/
  disDisabilityCertificateType: number;
  /*Thời điểm cấp giấy chứng nhận khuyết tật*/
  disDisabilityCertificateTypeDate: string;
  /*Thời điểm khuyết tật*/
  disabilityMomentId: number;
  /*Độ tuổi phát hiện KT*/
  detectionYearOld: number;
  /*Nguyên nhân*/
  causeId: number;
  /*Dạng tật*/
  typeOfDisabilityId: number;
  /*Mức độ khuyết tật*/
  levelId: number;
  /*Được hỗ trợ giáo dục*/
  supportedEducation: boolean;
  /*=====S==================Tinh trang giao duc==================S=====*/
  educationalStatusId: number;
  /*------Đang đi hoc phai chon*/
  studyingClassYear: string;
  /*Hinh thuc giao duc*/
  studyModeId: number;
  /*------Da bo hoc phai chon*/
  droppedOutClassYear: string;
  droppedOutNote: string;
  /*------Chua di hoc phai nhap*/
  notYetLearnedNote: string;
  /*------Da hoan thanh phai nhap*/
  /* Cap hoc*/
  schoolLevelId: number;
  /*Trinh do dao tao*/
  educationLevelId: number;
  /*=====E==================Tinh trang giao duc==================E=====*/

  /*=====S==================Tinh trang can thiep - nhu cau ho tro NKT==================S=====*/
  listStudentInterventionStatus: any[];
  interventioned: boolean;
  interventionNote: string;
  /*=====E==================Tinh trang can thiep - nhu cau ho tro NKT==================E=====*/
  /*Tình trạng việc làm*/
  employmentStatusId: number;
  /*Tình trạng hôn nhận*/
  maritalStatusId: number;
  /*Đang sống tại*/
  caregiverId: number;
  /* B. THÔNG TIN VỀ MỨC ĐỘ PHÁT TRIỂN*/
  listStudentLevelOfDevelopment: any[];
  /*  C. NHU CẦU HỖ TRỢ, GIÁO DỤC*/
  /*  StudentSurveyEducationSupport*/
  listStudentEducationSupport: any[];
  /*Chon phuong thuc giao duc*/
  modesOfEducationId: number;
  /*Phuong tien, thiet bi giao duc*/
  educationFacilitiesEquipment: string;
  /*Phuong tien ho tro ca nhan*/
  personalVehicle: string;
  /*Hoc nghe*/
  apprenticeNote: string;
  /*Ho tro khac*/
  educationalSupportNote: string;
  /* D. NHẬN THỨC VỀ CHÍNH SÁCH GIÁO DỤC CHO NGƯỜI KHUYẾT TẬT*/
  /*1. Biet chinh sach GD cho NKT*/
  /*  StudentSurveyDisabilityPolicy*/
  listStudentDisabilityPolicy: any[];
  understandDisabilityPolicy: boolean;
  /*Chinh sach GD cho nguoi khuyet tat khac*/
  disabilityPolicyNote: string;
  /*2. Tiep nhan thong tin ve cac chinh sach nguon*/
  /* StudentSurveyInformationSource*/
  listStudentInformationSource: any[];
  /*Tiep nhan thong tin ve cac chinh sach nguon khac*/
  informationSourceNote: string;
  /*3. Su phoi hop cua cong dong thuc hien chinh sach giao duc nguoi khuyet tat*/
  communityCoordination: boolean;
  communityCoordinationId: number;
  /*4. Su phoi hop cua chinh quyen va ban, nganh dia phuong*/
  localGovernmentCoordination: boolean;
  localGovernmentCoordinationId: number;
  /*  E. QUÁ TRÌNH HỌC TẬP*/
  listDisStudentLearningProcess: any[];
  educationAndTrainingOrSchoolId: number;
  dayOfBirth: any;
  monthOfBirth: any;
  tutorRelationshipId: any;
  disDisabilityCertificateTypeInYear: number;
  /*Nhập khi chọn đang sống tại là khác */
  caregiver: string;
  tutorRelationship: string;
  tutorProvinceId?: number;
  tutorDistrictId?: number;
  tutorWardId?: number;
  disability : string;
  disabilityCertificate : string;
}
